<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <el-input size="mini" v-model="search.PositionName" placeholder="职位名称搜索" class="etms-router-search-element fl"></el-input>
      <el-tooltip class="item" effect="dark" content="添加职位信息" placement="top">
        <el-button size="mini" @click="insetrPosition" class="etms-router-search-button fr" type="primary" icon="el-icon-plus"></el-button>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="查询职位信息" placement="top">
        <el-button size="mini" @click="searchClick" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-table :border="true" :data="positions" height="90%" class="etms-router-list">
      <el-table-column type="index" label="序号" header-align="center" align="center"></el-table-column>
      <el-table-column label="职位名" prop="positionName"></el-table-column>
      <el-table-column label="备注" prop="remarks"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="职位权限设置" placement="top">
            <el-button size="mini" type="success" @click="handlePower(scope.$index,scope.row)" icon="el-icon-setting" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="修改职位信息" placement="top">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除职位" placement="top">
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)" icon="el-icon-delete" circle></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" :modal-append-to-body="false" width="500px" center>
      <el-form :model="form" :rules="rules" :ref="form.formname" label-width="120px" class="etms-dialog-form">
        <el-form-item label="职位名称 ：" prop="PositionName">
          <el-input size="mini" v-model="form.PositionName" placeholder="请输入职位名称" class="el-width-300"></el-input>
        </el-form-item>
        <el-form-item label="备注 ：" prop="Remarks">
          <el-input size="mini" v-model="form.Remarks" placeholder="职位备注信息(可空)" class="el-width-300"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="dialogSave">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="power.dialogtitle" :visible.sync="power.dialogvisible" :modal-append-to-body="false" width="700px" center>
      <div style="width:100%; height:500px;overflow:auto;">
        <div v-for="item in power.menus.filter(m=>m.parentMenuId==='00000000-0000-0000-0000-000000000000')" :key="item.id">
          <i :class="(item.style === ''?'el-icon-minus':item.style)" style="cursor:pointer;" @click="powerShow(item.id)"></i>
          <el-checkbox v-model="item.checked" :label="item.menuName" @change="menuChange(item,[])"></el-checkbox>
          <div v-for="menu in power.menus.filter(m=>m.parentMenuId === item.id)" :key="menu.id" v-show="menu.show" style="padding-left:30px;">
            <i :class="(menu.style === ''?'el-icon-minus':menu.style)" style="cursor:pointer;" @click="powerShow(menu.id)"></i>
            <el-checkbox v-model="menu.checked" :label="menu.menuName" @change="menuChange(menu,[item])"></el-checkbox>
            <div v-for="child in power.menus.filter(m=>m.parentMenuId === menu.id)" :key="child.id" v-show="child.show" style="padding-left:30px;">
              <el-checkbox v-model="child.checked" :label="child.menuName" @change="menuChange(child,[menu,item])"></el-checkbox>
              <div style="padding-left:30px;">
                <el-checkbox v-for="fun in power.functions.filter(f=>f.menuId===child.id)" :key="fun.id" v-model="fun.checked" :label="fun.functionName" @change="functionChange(fun,[child,menu,item])"></el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="power.dialogvisible=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="powerSaveClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    var positionNameValidate = (rule, value, callback) => {
      var self = this
      var userinfo = this.$cookies.get('userinfo')
      if (userinfo !== null && userinfo !== undefined) {
        this.$ajax.post(this.constant.openPaths.existsPositionName, {
          UserId: userinfo.id,
          EnterpriseId: userinfo.enterpriseId,
          LoginToken: userinfo.loginToken,
          PositionName: value,
          PositionId: self.form.PositionId
        }).then(res => {
          if (res.data.code == 200) { callback() }
          else { callback(res.data.Msg) }
        }).catch(error => { callback(error) })
      }
    }
    return {
      userinfo: this.$cookies.get('userinfo'),
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        PositionName: '',
      },
      dialogtitle: '',
      dialogvisible: false,
      form: {
        formname: 'positionform',
        OptimisticLock: '',
        PositionId: '',
        PositionName: '',
        Remarks: ''
      },
      positions: [],
      power: {
        dialogtitle: '权限设置',
        dialogvisible: false,
        menus: [],
        functions: [],
        PositionId: ''
      },
      rules: {
        PositionName: [
          { required: true, message: '请输入职位名称', trigger: 'blur' },
          { max: 100, message: '长度请控制在100个字符以内', trigger: 'blur' },
          { validator: positionNameValidate, trigger: 'blur' }
        ],
        Remarks: [
          { max: 500, message: '长度请控制在500个字符以内', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.searchClick()
  },
  methods: {
    searchClick () {
      var self = this
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          PositionName: this.search.PositionName
        }
        this.$ajax.post(this.constant.openPaths.searchPositionPager, data).then(res => {
          if (res.data.code === 200) {
            var result = res.data.result
            self.positions = result.tList
            self.search.recordcount = result.recordCount
          } else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    clearForm () {
      var form = this.form
      Object.keys(form).forEach(item => {
        if (item !== 'formname') {
          switch (typeof (form[item])) {
            case 'string':
              form[item] = ''
              break
            case 'number':
              form[item] = 0
              break
            case 'object':
              if (Array.isArray(form[item])) {
                form[item] = []
              } else { }
              break
          }
        }
      })
    },
    insetrPosition () {
      this.dialogtitle = "新建职位"
      this.dialogvisible = true
      this.clearForm()
    },
    handleEdit (index, row) {
      this.dialogvisible = true
      this.dialogtitle = '修改职位'
      this.form.OptimisticLock = row.optimisticLock
      this.form.PositionId = row.id
      this.form.PositionName = row.positionName
      this.form.Remarks = row.remarks
    },
    handleDelete (index, row) {
      var self = this
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PositionId: row.id,
          OptimisticLock: row.optimisticLock
        }
        this.$confirm('此操作将永久删除该职位,删除后不可恢复,是否继续', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax.post(this.constant.openPaths.deletePosition, data).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              self.deps.splice(index, 1)
            } else {
              self.$message.error(res.data.code)
            }
          }).catch(error => {
            self.$message.error(error)
          })
        })
      }
    },
    handleSizeChange (val) {
      this.pagesize = val
      this.searchClick()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.searchClick()
    },
    dialogSave () {
      var self = this
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        PositionId: this.form.PositionId,
        OptimisticLock: this.form.OptimisticLock,
        PositionName: this.form.PositionName,
        Remarks: this.form.Remarks
      }

      var url = ''
      if (data.PositionId === '' && data.OptimisticLock === '') {
        url = this.constant.openPaths.insertPosition
      }
      else {
        url = this.constant.openPaths.updatePosition
      }
      this.$refs[this.form.formname].validate((valid) => {
        if (valid) {
          self.$ajax.post(url, data).then(res => {
            if (res.data.code === 200) {
              self.$message({ message: res.data.msg, type: 'success' })
              self.clearForm()
              self.searchClick()
              self.dialogvisible = false
            } else { self.$message.error(res.data.msg) }
          }).catch(error => {
            self.$message.error(error)
          })
        }
      })
    },
    handlePower (index, row) {
      this.power.PositionId = row.id
      this.power.dialogvisible = true
      this.power.menus = []
      this.power.functions = []
      this.getPositionMenus()
      this.getPositionFunctions()
    },
    getPositionMenus () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PositionId: this.power.PositionId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getPositionMenus, data).then(res => {
          if (res.data.code === 200) {
            self.power.menus = res.data.result
          }
          else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    getPositionFunctions () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PositionId: this.power.PositionId
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.getPositionFunctions, data).then(res => {
          if (res.data.code === 200) {
            self.power.functions = res.data.result
          }
          else {
            self.$message.error(res.data.msg)
          }
        }).catch(error => {
          self.$message.error(error)
        })
      }
    },
    powerShow (menuid) {
      var menu = this.power.menus.filter(m => m.id === menuid)[0]
      if (menu.style === '' || menu.style == 'el-icon-minus') {
        menu.style = 'el-icon-plus'
      } else {
        menu.style = 'el-icon-minus'
      }
      this.power.menus.filter(m => m.parentMenuId === menuid).forEach(item => {
        item.show = menu.style === 'el-icon-minus'
      })
    },
    menuChange (item, array) {
      if (item.checked) {
        array.forEach((menu, index) => {
          menu.checked = item.checked
        })
      } else {
        this.eachChildMenu(item.id, item.checked)
      }
    },
    functionChange (item, array) {
      if (item.checked) {
        array.forEach(menu => {
          menu.checked = item.checked
        })
      }
    },
    eachChildMenu (id, checked) {
      this.power.functions.filter(f => f.menuId === id).forEach(fun => {
        fun.checked = checked
      })
      this.power.menus.filter(m => m.parentMenuId === id).forEach(item => {
        item.checked = checked
        this.power.functions.filter(f => f.menuId === item.id).forEach(fun => {
          fun.checked = checked
        })
        this.eachChildMenu(item.id, checked)
      })
    },
    powerSaveClick () {
      var menuids = new Array()
      this.power.menus.filter(m => m.checked).forEach(item => {
        menuids.push(item.id)
      })
      var funids = new Array()
      this.power.functions.filter(f => f.checked).forEach(item => {
        funids.push(item.id)
      })

      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken,
        PositionId: this.power.PositionId,
        MenuIds: menuids,
        FunctionIds: funids
      }
      var self = this
      this.$ajax.post(this.constant.openPaths.settingPositionPower, data).then(res => {
        if (res.data.code === 200) {
          self.$message({ message: res.data.msg, type: 'success' })
        } else {
          self.$message.error(res.data.msg)
        }
      }).catch(error => { self.$message.error(error) })
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/ems/position_manage.vue